import React, { useState, useContext } from 'react';
import './style.css';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import { WindowSizeContext } from '/src/App';

const HelpMeChooseQuestionnaire = ({
    budgetInput,
    paybackInput,
    diyInput,
    maxProjectsInput,
    categoryInput,
    totalProjects,
    setQuestionnaireCompleted,
    requiresDiscountsInput
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const [currentQuestion, setCurrentQuestion] = useState(0);

    const questions = [
        {
            stage: 1,
            question: "How much are you open to spending on home improvements?",
            input: budgetInput,
        },
        // {
        //     stage: 2,
        //     question: "How many years can you wait for a return on your investment?",
        //     input: paybackInput,
        // },
        // {
        //     stage: 3,
        //     question: "How important is who does the work?",
        //     input: diyInput,
        // },
        // {
        //     stage: 4,
        //     question: "How important is accessing known discounts?",
        //     input: requiresDiscountsInput,
        // },
        // {
        //     stage: 4,
        //     question: "How many projects are you open to taking on?",
        //     input: maxProjectsInput,
        // },
        // {
        //     stage: 5,
        //     question: "What parts of the house do you want to improve?",
        //     input: categoryInput,
        // },
    ]

    const questionnaireIntroSentence = `With ${totalProjects} projects to choose from, it can be tough to know where to start. Let's help you narrow that list down, we just need to know one thing:`


    const handleBackButton = () => {
        if (currentQuestion > 0) {
            setCurrentQuestion(currentQuestion - 1);
        }
    }

    const handleNextButton = () => {
        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
        }
    }

    const handleCompleteButton = () => {
        setQuestionnaireCompleted(true);
    }


    const buttonText = "Start Narrowing Down Projects"

    return (
        <div className={`help-me-choose-questionnaire ${deviceType}`}>
            <div className={`help-me-choose-questionnaire__content-container ${deviceType}`}>
                {/* <h1>Help Me Choose The Right Projects</h1> */}
                <p className='text-align-center'>{questionnaireIntroSentence}</p>
                <div className={`help-me-choose-questionnaire__questions-container ${deviceType}`}>
                    {questions.map((question, index) => (
                        <div key={index} className={`help-me-choose-questionnaire__question-container ${deviceType}`}>
                            <h3 className='text-align-center'>{question.question}</h3>
                            {question.input}
                        </div>
                    ))}
                </div>
                <CTAButton text={buttonText} onClick={() => handleCompleteButton()} />
            </div>
           
        </div >
    )
}

export default HelpMeChooseQuestionnaire;